export default __webpack_public_path__ + "static/media/WF.8715f036.svg";